<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import axios from "axios";
// import kepribadianVue from "../kepribadian.vue";
// import kecerdasanVue from "../kecerdasan.vue";
import kecermatanVue from "../kecermatan.vue";
import lainnyaVue from "../lainnya.vue";
import loadingVue from "@/components/loading.vue";
import "@/assets/scss/custom-layout-ujian.scss";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    // kepribadianVue,
    // kecerdasanVue,
    kecermatanVue,
    lainnyaVue,
    loadingVue,
  },
  page: {
    title: "Ujian Start",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      setParamsId: this.$route.params.id,
      setCekDetailUjian: null,
      setLengthDataId: null,
      setDataIdSoal: null,
      setSoal: null,
      setCheckSoal: null,
      currentIndex: 0,
      isDisabled: true,
      isFinish: false,
      isLoading: true,
      timer: "",
      examTime: null,
      showNotice: false,
      setListSoal: null,
      foundItems: [],
      setJawabCheckbox: [],
      setDataMultiple: false,
      currentIndexKecermatan: 0,
      currentIndexSoalAll: 0,
      minJawab: true,
      forIndexSoal: 0,
      dataSoalKecermatan: [],
      dataSoalExamAll: [],
      setUserBySoal: null,
      isMethodExecuted: false,
      setKolom: null,
      dividedArray: [],
      currentIndexKolom: 1,
      timerInterval: 0,
      jawabanUser: [],
      loadButton: false,
    };
  },
  watch: {
    // setLengthDataId(leng) {
    //   if (leng !== 0 || leng !== null) {
    //     if (!this.isMethodExecuted) {
    //       this.divideArray();
    //       this.isMethodExecuted = true;
    //     }
    //   }
    // },
  },
  /**
   * Mounted lifecycle hook.
   *
   * This method is called when the component is mounted to the DOM.
   * It adds an event listener to the document to prevent the context menu from appearing.
   * It also calls the getViewUjian method to retrieve the data for the ujian.
   * Additionally, it sets the display property of the navbar-content and footer-section elements to none.
   * Finally, it sets the padding property of the page-content-section element to 0.
   * It also adds an event listener to the window to handle the beforeunload event.
   */
  mounted() {
    document.addEventListener(
      "contextmenu",
      function(event) {
        event.preventDefault();
      },
      false
    );
    this.getViewUjian();
    const navbar = document.getElementById("navbar-content");
    const footer = document.getElementById("footer-section");
    const pageContent = document.getElementById("page-content-section");

    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";
    if (pageContent) pageContent.style.padding = "0";
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  /**
   * Destroy lifecycle hook.
   *
   * This method is called when the component is destroyed.
   * It removes the event listener from the window that was added to handle the beforeunload event.
   */
  destroyed() {
    const navbar = document.getElementById("navbar-content");
    const footer = document.getElementById("footer-section");
    const pageContent = document.getElementById("page-content-section");

    if (navbar) navbar.style.display = "";
    if (footer) footer.style.display = "";
    if (pageContent) pageContent.style.padding = "";
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    /**
     * Handle before unload event
     * @param {Event} event - Event object
     *
     * This function is called when user tries to close the browser or navigate to other page.
     * It prevents the default behaviour of the event and shows a confirmation dialog to user.
     * The confirmation dialog is only shown if the user has not finished the exam.
     */
    handleBeforeUnload(event) {
      console.log(event);
      event.preventDefault();
      // event.returnValue = 'Apakah Anda yakin ingin meninggalkan halaman ini?'; // Required for some browsers
    },

    /**
     * Get detail ujian by id
     *
     * @return {Object} response.data
     */
    async getDetailUjian() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-ujian-detail/" +
            this.setParamsId
        )
        .then(async (response) => {
          this.setCekDetailUjian = response.data;
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },

    /**
     * Get view ujian by id
     *
     * @return {Object} response.data
     */
    async getViewUjian() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-ujian-detail/" +
            this.setParamsId
        )
        .then(async (response) => {
          // localStorage.setItem("cekPaketSoal", JSON.stringify(response.data));
          if (response.data.is_answered && response.data.is_finished) {
            window.location = "/scores";
          } else {
            await this.getDetailUjian();
            await this.getDataIdSoal();
          }
          // await this.getDetailUjian();
          // await this.getDataIdSoal();
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        });
    },

    /**
     * Get data id soal by id ujian
     *
     * @return {Object} response.data
     */
    async getDataIdSoal() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-ujian/" +
            this.setParamsId +
            "/start"
        )
        .then(async (response) => {
          const configuredCount = Number(this.setCekDetailUjian && this.setCekDetailUjian.length_soal);
          const useConfiguredCount = this.setCekDetailUjian && this.setCekDetailUjian.paket !== "Test Kecermatan" && configuredCount > 0;
          const questionIds = useConfiguredCount
            ? response.data.slice(0, configuredCount)
            : response.data;

          this.setLengthDataId = questionIds.length;
          this.setDataIdSoal = questionIds;
          await this.divideArray();
          await this.getSoal();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /**
     * Get soal kecermatan by id ujian
     *
     * This function is used to get the kecermatan soal by id ujian.
     * The response of this function is stored in the dataSoalKecermatan variable.
     * The isLoading variable is set to false when the promise is resolved.
     * If there is an error, the error is logged to the console.
     */
    async getSoalForKecermatan() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-soal-kecermatan/" +
            this.setParamsId
        )
        .then(async (response) => {
          this.isLoading = false;
          this.dataSoalKecermatan = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    async getSoalForAllExam() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-soal-all/" +
            this.setParamsId
        )
        .then(async (response) => {
          this.isLoading = false;
          this.dataSoalExamAll = response.data.slice(0, this.setLengthDataId || response.data.length);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /**
     * Get soal by id ujian
     * @param {string} mode - mode of get soal, can be "fetchNext" or "fetchPrev"
     * @param {string} val - value of mode, can be "fetchNext" or "fetchPrev"
     * @return {Object} response.data
     *
     * This function is used to get the soal by id ujian.
     * The response of this function is stored in the setSoal variable.
     * The isLoading variable is set to false when the promise is resolved.
     * If there is an error, the error is logged to the console.
     * If the mode is "fetchNext", the function will call the getSoalForKecermatan function to get the kecermatan soal.
     * If the mode is "fetchPrev", the function will call the getSoalForKecermatan function to get the kecermatan soal.
     * If the mode is "getSoalByModal", the function will call the getSoalForKecermatan function to get the kecermatan soal.
     */
    async getSoal(mode = null, val) {
      this.isLoading = true;

      const totalQuestions = this.setLengthDataId || 0;
      const isRegularExam = this.setCekDetailUjian && this.setCekDetailUjian.paket !== "Test Kecermatan";

      if (isRegularExam && (this.currentIndexSoalAll < 0 || this.currentIndexSoalAll >= totalQuestions)) {
        this.currentIndexSoalAll = Math.max(0, totalQuestions - 1);
        this.isFinish = true;
        this.isLoading = false;
        return;
      }

      if (val == "fetchNext") {
        if (this.currentIndex < this.setLengthDataId) {
          await axios
            .get(
              process.env.VUE_APP_API_BASE_URL +
                "/api/json/get-soal/" +
                this.setDataIdSoal[this.currentIndex]
            )
            .then(async (response) => {
              this.isLoading = false;
              this.setSoal = response.data;
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      } else if (val == "fetchPrev") {
        if (this.currentIndex < this.setLengthDataId) {
          if (this.currentIndex > 0) {
            await axios
              .get(
                process.env.VUE_APP_API_BASE_URL +
                  "/api/json/get-soal/" +
                  this.setDataIdSoal[this.currentIndex]
              )
              .then(async (response) => {
                this.isLoading = false;
                this.setSoal = response.data;
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        }
      } else if (val == "getSoalByModal") {
        await axios
          .get(
            process.env.VUE_APP_API_BASE_URL +
              "/api/json/get-soal/" +
              this.setDataIdSoal[this.currentIndexSoalAll]
          )
          .then(async (response) => {
            this.isLoading = false;
            this.setSoal = response.data;
          })
          .catch(function(error) {
            console.log(error);
          });
      }

      if (this.setCekDetailUjian.paket === "Test Kecermatan") {
        if (this.currentIndex < this.setLengthDataId) {
          if (this.currentIndexKecermatan == 0) {
            await this.getSoalForKecermatan();
            this.setSoal = this.dataSoalKecermatan.data_cermat[
              this.currentIndexKecermatan
            ];
            this.setUserBySoal = this.dataSoalKecermatan.user_id;
            await this.startTimer();
          } else {
            this.isLoading = false;
            this.setSoal = this.dataSoalKecermatan.data_cermat[
              this.currentIndexKecermatan
            ];
            return true;
          }
        }
      } else {
        if (this.currentIndexSoalAll < this.setLengthDataId) {
          if (this.jawabanUser.length == 0) {
            await this.getSoalForAllExam();
            this.setSoal = this.dataSoalExamAll[this.currentIndexSoalAll];
            this.setUserBySoal = this.dataSoalExamAll.user_id;
            if (mode === null) {
              await this.startTimer();
            }
          } else {
            this.isLoading = false;
            this.setSoal = this.dataSoalExamAll[this.currentIndexSoalAll];
            return true;
          }

          // if (this.currentIndex == 0) {
          //   await axios
          //     .get(
          //       process.env.VUE_APP_API_BASE_URL +
          //         "/api/json/get-soal/" +
          //         this.setDataIdSoal[this.currentIndex]
          //     )
          //     .then(async (response) => {
          //       this.setSoal = response.data;
          //       await this.startTimer();
          //       this.isLoading = false;
          //     })
          //     .catch(function(error) {
          //       console.log(error);
          //     });
          // } else {
          //   this.isLoading = false;
          //   return true;
          // }
        }
      }
    },

    /**
     * Start timer for the exam. If the exam is Test Kecermatan, it will start a new timer
     * for each kolom. If the exam is not Test Kecermatan, it will start a timer for the
     * entire exam.
     *
     * @returns {void}
     */
    async startTimer() {
      // console.log(1);
      if (this.setCekDetailUjian !== null) {
        // console.log(2);
        let examTime =
          60 *
          parseInt(
            this.setCekDetailUjian.paket == "Test Kecermatan"
              ? this.setCekDetailUjian.waktu_per_kolom
              : this.setCekDetailUjian.waktu
          );
        // let examTime = 60 * 0.2;
        let endTime = new Date().getTime() + examTime * 1000;

        if (this.timerInterval) {
          // console.log(3);
          clearInterval(this.timerInterval);
        }

        this.timerInterval = setInterval(() => {
          // console.log(4);
          let now = new Date().getTime();
          let distance = endTime - now;

          let hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          this.timer = `${this.padZero(hours)}:${this.padZero(
            minutes
          )}:${this.padZero(seconds)}`;

          if (distance < 15000) {
            console.log(5);
            this.showNotice = true;
          }

          if (distance < 0) {
            console.log(6);
            if (
              this.setCekDetailUjian.paket == "Test Kecermatan" &&
              this.currentIndexKolom < this.setKolom
            ) {
              console.log(7);
              clearInterval(this.timerInterval);
              this.startTimer();
              this.currentIndexKolom += 1;
              this.currentIndexKecermatan =
                (this.setCekDetailUjian.soal_per_kolom + 1) *
                (this.currentIndexKolom - 1);
              this.getSoal();
              this.currentIndex = 0;
              this.showNotice = false;
            } else {
              console.log(8);
              clearInterval(this.timerInterval);
              this.showNotice = false;
              this.timer = "Waktu Habis";
              this.$refs["modal-waktu-habis"].show();
            }
          }
        }, 1000);
      }
    },

    /**
     * Pad a number with a leading zero if it is less than 10
     * @param {number} num - number to pad
     * @return {string} padded number as a string
     */
    padZero(num) {
      return num.toString().padStart(2, "0");
    },

    /**
     * Fetch the next soal and update the component state
     * @fires getSoal
     * @listens getSoal
     */
    /**
     * Immediately persist answers that are still waiting for the child's
     * autosave interval (relevant for multi-correct checkboxes, whose
     * selection does not auto-advance) before navigating away.
     */
    async flushPendingAnswers() {
      const lainnya = this.$refs.lainnyaRef;
      if (
        lainnya &&
        Array.isArray(lainnya.dataJawab) &&
        lainnya.dataJawab.length > 0
      ) {
        await lainnya.simpanJawaban();
      }
    },

    async fetchNext() {
      await this.flushPendingAnswers();
      // this.currentIndexSoalAll += 1;
      // await this.getSoal();

      // this.isLoading = true;
      // this.minJawab = true;
      // this.setSoal.soal.kunci.includes(",")
      //   ? this.checkMultiple(true)
      //   : this.checkMultiple(false);

      // console.log(
      //   this.currentIndexSoalAll + 1 === this.setDataIdSoal.length,
      //   this.currentIndexSoalAll,
      //   this.setDataIdSoal.length
      // );

      const totalQuestions = this.setDataIdSoal ? this.setDataIdSoal.length : 0;

      if (this.currentIndexSoalAll >= totalQuestions - 1) {
        this.isFinish = true;
        this.isLoading = false;
        return;
      }

      this.currentIndexSoalAll += 1;
      await this.getSoal();
      this.isDisabled = false;

      if (this.currentIndexSoalAll === totalQuestions - 1) {
        this.isFinish = true;
      }
    },

    /**
     * Fetch the previous soal and update the component state
     * @fires getSoal
     * @listens getSoal
     */
    async fetchPrev() {
      await this.flushPendingAnswers();
      // this.currentIndexSoalAll -= 1;
      // if (this.currentIndexSoalAll !== 0) {
      //   await this.getSoal();
      // }
      // this.isLoading = true;
      // this.minJawab = true;
      if (this.currentIndexSoalAll > 0) {
        this.currentIndexSoalAll -= 1;
        await this.getSoal();
        if (this.currentIndexSoalAll === 0) {
          this.isDisabled = true;
        } else if (this.currentIndexSoalAll < this.setDataIdSoal.length) {
          this.isFinish = false;
        }
      }
    },

    /**
     * Read the next soal based on the type of exam. If the exam is Test Kepribadian,
     * it will check if the current index is equal to the length of setDataIdSoal. If
     * it is, it will show the modal waktu habis and disable the button. Otherwise,
     * it will increment the current index and fetch the next soal. If the exam is
     * Test Kecermatan, it will check if the current index is equal to the length of
     * setLengthDataId. If it is, it will show the modal waktu habis and disable the
     * button. Otherwise, it will increment the current index and fetch the next soal.
     * If the exam is not Test Kepribadian or Test Kecermatan, it will check if the
     * current index is equal to the length of setLengthDataId. If it is, it will show
     * the modal waktu habis and disable the button. Otherwise, it will increment the
     * current index and fetch the next soal.
     * @fires getSoal
     * @listens getSoal
     */
    async readSoal() {
      if (this.setCekDetailUjian.paket === "Test Kecermatan") {
        if (this.currentIndexKecermatan + 1 === this.setLengthDataId) {
          this.isFinish = true;
          // this.currentIndex = this.setDataIdSoal.length - 1;
          this.$refs["modal-waktu-habis"].show();
          this.isLoading = false;
          clearInterval(this.timerInterval);
        } else {
          if (this.currentIndex + 1 == this.setCekDetailUjian.soal_per_kolom) {
            this.currentIndex = 0;
            this.currentIndexKecermatan += 1;
            this.currentIndexKolom += 1;
            await this.startTimer();
          } else {
            this.currentIndex += 1;
            this.setSoal = null;
            this.currentIndexKecermatan += 1;
            this.isDisabled = false;
            await this.getSoal();
          }
        }
      } else {
        // console.log(19);
        if (this.currentIndexSoalAll >= this.setLengthDataId - 1) {
          // console.log(20);
          this.isFinish = true;
          this.currentIndex = this.setDataIdSoal.length - 1;
          this.$refs["modal-waktu-tersisa"].show();
          this.isLoading = false;
        } else {
          // console.log(20);
          // this.currentIndexSoalAll += 1;
          this.isDisabled = false;
          // await this.getSoal();
          this.fetchNext();
          // await this.getSoal("onclickEvent");
        }
      }
    },

    /**
     * Set setDataMultiple true or false
     * @param {boolean} data - value of setDataMultiple
     */
    async checkMultiple(data) {
      if (data !== true) {
        this.setDataMultiple = false;
      } else {
        this.minJawab = true;
        this.setDataMultiple = true;
      }
    },

    /**
     * Function to get soal by index and show the modal soal detail
     * @param {number} data - index of soal to get
     *
     * This function will be called when the user click the soal number in the daftar soal modal
     * This function will set the currentIndex to the data param, call the getSoal function with the "getSoalByModal" param,
     * and then hide the daftar soal modal
     * If the currentIndex is 0, the isDisabled will be set to true, else it will be set to false
     * If the currentIndex + 1 is less than the setDataIdSoal.length, the isFinish will be set to false, else it will be set to true
     */
    async listSoal(data) {
      console.log(data);
      if (this.setDataIdSoal !== null && data >= 0 && data < this.setDataIdSoal.length) {
        this.currentIndexSoalAll = data;
        this.currentIndex = data;
        await this.getSoal("getSoalByModal");
        if (this.currentIndex === 0) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
        if (this.currentIndex + 1 < this.setDataIdSoal.length) {
          this.isFinish = false;
        } else {
          this.isFinish = true;
        }
        this.$refs["modal-daftar-soal"].hide();
      }
    },

    /**
     * Function to get all jawaban by id ujian and id soal
     *
     * This function will be called when the user click the button "Lihat Daftar Soal" in the ujian page
     * This function will call the axios get method with the "/api/json/ujian/get-jawab-all/" endpoint and the id ujian and id soal as params
     * The response data will be set to the setListSoal variable
     * The foundItems will be set to the setDataIdSoal filtered by the setListSoal
     */
    async buttonListSoal() {
      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/ujian/get-jawab-all/" +
            this.setParamsId
        )
        .then((response) => {
          this.setListSoal = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
      this.foundItems = this.setDataIdSoal.filter((item) => {
        return this.setListSoal.some((otherItem) => {
          return parseInt(otherItem.no_soal_id) === item;
        });
      });
    },

    async refreshSoal() {
      if (!this.setSoal || !this.setSoal.soal) {
        return;
      }

      this.isLoading = true;

      await axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "/api/json/get-soal/" +
            this.setSoal.soal.id
        )
        .then(async (response) => {
          this.isLoading = false;
          this.setSoal = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /**
     * Function to send all the answers to the server
     * @fires post method to /api/json/ujian/kirim-jawaban
     *
     * This function will be called when the user click the button "Selesai" in the ujian page
     * This function will call the axios post method with the "/api/json/ujian/kirim-jawaban" endpoint and the id soal as params
     * If the paket is "Test Kecermatan", it will show the loading modal and call the axios post method twice
     * If the paket is not "Test Kecermatan", it will call the axios post method once
     * After the axios call is success, it will remove the "data_jawab" localStorage and redirect the user to the finish page
     * If the axios call is failed, it will show the error in the console
     */
    async kirimJawaban() {
      console.log("kirim jawaban Test");
      const previousUrl = localStorage.getItem("previousUrl");

      if (this.setCekDetailUjian.paket !== "Test Kecermatan") {
          this.loadButton = true;
      }

      console.log("Menunggu 2 detik untuk memastikan semua jawaban terkirim...");
      await new Promise(resolve => setTimeout(resolve, 5000));

      if (this.setCekDetailUjian.paket === "Test Kecermatan") {
        this.$refs["modal-loading-soal"].show();
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/api/json/ujian/kirim-jawaban",
            {
              id_soal: parseInt(this.setParamsId),
            }
          )
          .then(async () => {
            localStorage.removeItem("data_jawab");
            localStorage.removeItem("previousUrl"); // Hapus previousUrl setelah digunakan
            this.$router.push(
              previousUrl || "/student/ujian/" + this.setParamsId + "/finish"
            );
            this.$refs["modal-loading-soal"].hide();
            this.loadButton = false;
          })
          .catch(async (error) => {
            this.$refs["modal-loading-soal"].hide();
            Swal.fire({
              icon: "error",
              title: "Gagal Mengirim Jawaban",
              text:
                "Koneksi Internet Tidak Stabil. Silahkan cek koneksi internet Anda dan coba lagi.",
              confirmButtonColor: "#503668",
            });
            console.log(error);
            this.loadButton = false;
          });
      } else {
        this.loadButton = true;
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/api/json/ujian/kirim-jawaban",
            {
              id_soal: parseInt(this.setParamsId),
            }
          )
          .then(async () => {
            localStorage.removeItem("data_jawab");
            localStorage.removeItem("previousUrl");
            this.jawabanUser = [];
            this.$router.push(
              previousUrl || "/student/ujian/" + this.setParamsId + "/finish"
            );
            this.loadButton = false;
          })
          .catch((error) => {
            this.loadButton = false;
            Swal.fire({
              icon: "error",
              title: "Gagal Mengirim Jawaban",
              text:
                "Koneksi Internet Tidak Stabil. Silahkan cek koneksi internet Anda dan coba lagi.",
              confirmButtonColor: "#503668",
            });
            console.log(error);
          });
      }
    },

    /**
     * @function jawabSoalCheckbox
     * @description Method to store user answer for checkbox type question
     * @param {Array} jawabCheckbox - Answer from user
     * @return {void}
     */
    async jawabSoalCheckbox(jawabCheckbox) {
      this.setJawabCheckbox = jawabCheckbox;
      if (this.setJawabCheckbox.length > 1) {
        this.setJawabCheckbox.sort();
      }
    },

    /**
     * @function submitCheckbox
     * @description Method to send all the answers to the server
     *
     * This function will be called when the user click the button "Selanjutnya" in the ujian page
     * This function will check if the user already answer the question or not
     * If the user already answer the question, it will send the answer to the server using the axios post method
     * If the user not answer the question, it will show the warning modal
     * After the axios call is success, it will get the next question from the server and show it to the user
     * If the axios call is failed, it will show the error in the console
     *
     * @return {void}
     */
    async submitCheckbox() {
      this.isLoading = true;
      this.minJawab = true;
      const formData = new FormData();
      if (this.setJawabCheckbox.length > 1) {
        formData.append("get_jawab", this.setJawabCheckbox);
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/api/json/ujian/jawab",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(async (e) => {
            this.minJawab = true;
            if (this.currentIndex <= this.setDataIdSoal.length) {
              this.setSoal = e.data;
              this.setJawabCheckbox = [];
              this.isLoading = false;
              if (this.currentIndex !== 0) {
                this.isDisabled = false;
              }
            }
            if (this.currentIndex + 1 === this.setDataIdSoal.length) {
              this.isFinish = true;
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
      if (this.setJawabCheckbox.length === 1) {
        this.minJawab = false;
        this.isLoading = false;
        this.setJawabCheckbox = [];
        if (this.currentIndex !== 0) {
          this.isDisabled = false;
        }
      } else if (this.setJawabCheckbox.length === 0) {
        if (this.currentIndex <= this.setDataIdSoal.length) {
          await this.fetchNext();
          if (this.currentIndex !== 0) {
            this.isDisabled = false;
          }
        }
        if (this.currentIndex + 1 === this.setDataIdSoal.length) {
          this.isFinish = true;
        }
      }
    },

    /**
     * @function cancelModal
     * @description Method to cancel the modal
     *
     * This function will be called when the user click the button "Batal" in the modal waktu tersisa
     * This function will hide the modal and set the isLoading variable to false
     *
     * @return {void}
     */
    async cancelModal() {
      this.isLoading = false;
      this.$refs["modal-waktu-tersisa"].hide();
    },

    /**
     * Function to send all the answers to the server
     * @fires post method to /api/json/ujian/jawab
     *
     * This function will be called when the user click the button "Simpan Jawaban" in the ujian page
     * This function will check if the user already answer the question or not
     * If the user already answer the question, it will send the answer to the server using the axios post method
     * If the user not answer the question, it will show the warning modal
     * After the axios call is success, it will get the next question from the server and show it to the user
     * If the axios call is failed, it will show the error in the console
     *
     * @return {void}
     */
    async submitConfirm() {
      await this.flushPendingAnswers();
      this.isLoading = true;
      this.minJawab = true;
      const formData = new FormData();
      if (this.setJawabCheckbox.length > 1) {
        formData.append("get_jawab", this.setJawabCheckbox);
        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + "/api/json/ujian/jawab",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then(async () => {
            if (this.currentIndex + 1 === this.setDataIdSoal.length) {
              this.$refs["modal-waktu-tersisa"].show();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      } else if (this.setJawabCheckbox.length === 1) {
        this.minJawab = false;
        this.setJawabCheckbox = [];
      } else {
        this.$refs["modal-waktu-tersisa"].show();
      }
    },

    /**
     * Divide the array of soal into kolom based on the paket
     * If the paket is Test Kecermatan, it will divide the array into kolom
     * The setKolom variable will be set with the number of kolom
     *
     * @return {void}
     */
    async divideArray() {
      if (this.setCekDetailUjian.paket === "Test Kecermatan") {
        const arrayLength = this.setLengthDataId;
        const parts = this.setCekDetailUjian.soal_per_kolom;
        this.setKolom = Math.ceil(arrayLength / parts);
      }
    },
  },
};
</script>

<style scoped>
.card-footer {
  background: none;
  border: 0;
}
.custom-loader {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 16px solid #0000;
  border-right-color: #6f42c197;
  position: relative;
  animation: s4 1s infinite linear;
}
.custom-loader:before,
.custom-loader:after {
  content: "";
  position: absolute;
  inset: -16px;
  border-radius: 50%;
  border: inherit;
  animation: inherit;
  animation-duration: 2s;
}
.custom-loader:after {
  animation-duration: 4s;
}
.loader-button {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 10px solid #0000;
  border-right-color: #ffff;
  position: relative;
  animation: s4 1s infinite linear;
}
.loader-button:before,
.loader-button:after {
  content: "";
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  border: inherit;
  animation: inherit;
  animation-duration: 2s;
}
.loader-button:after {
  animation-duration: 4s;
}
#navbar-content {
  display: none !important;
}

@keyframes s4 {
  100% {
    transform: rotate(1turn);
  }
}
</style>

<template>
  <Layout id="exam-page">
    <b-modal ref="my-modal" hide-footer title="Using Component Methods">
      <div class="d-block text-center">
        <h3>Hello From My Modal!</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block>Close Me</b-button>
      <b-button class="mt-2" variant="outline-warning" block
        >Toggle Me</b-button
      >
    </b-modal>

    <div v-if="setCekDetailUjian">
      <b-modal
        ref="modal-waktu-habis"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
      >
        <template #modal-title><h5>Ujian Telah Berakhir</h5></template>
        <div class="d-block text-center fs-5">
          Selamat
          <strong class="text-capitalize">{{
            setCekDetailUjian && setCekDetailUjian.nama_user
          }}</strong
          >, anda telah menyelesaikan ujian
          <i>{{ setCekDetailUjian && setCekDetailUjian.paket }}</i
          >. Selanjutnya silahkan tekan tombol <strong>'Kirim'</strong> untuk
          melihat nilai.
        </div>
        <b-button
          class="mt-4 w-100"
          block
          variant="purple"
          @click="kirimJawaban"
          >Kirim</b-button
        >
      </b-modal>

      <b-modal
        id="bv-modal-waktu-tersisa"
        ref="modal-waktu-tersisa"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
      >
        <template #modal-title><h5>Ujian Telah Berakhir</h5></template>
        <div class="d-block text-center fs-5">
          Selamat
          <strong class="text-capitalize">{{
            setCekDetailUjian && setCekDetailUjian.nama_user
          }}</strong
          >, anda telah menyelesaikan ujian
          <i>{{ setCekDetailUjian && setCekDetailUjian.paket }}</i
          >. Selanjutnya silahkan tekan tombol <strong>'Kirim'</strong> untuk
          melihat nilai, atau tekan tombol <strong>Batal</strong> untuk
          mengoreksi jawaban kamu kembali.
        </div>
        <b-row>
          <b-col>
            <b-button
              style="height: 45px;"
              class="mt-4 w-100"
              block
              :disabled="loadButton"
              @click="cancelModal"
            >
              Batal
            </b-button>
          </b-col>
          <b-col>
            <b-button
              style="height: 45px;"
              class="mt-4 w-100 d-flex align-items-center justify-content-center"
              block
              variant="purple"
              :disabled="loadButton"
              @click="kirimJawaban"
            >
              <div class="loader-button" v-if="loadButton"></div>
              <span v-else>Kirim</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        ref="modal-loading-soal"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
      >
        <template #modal-title><h5>Ujian Telah Berakhir</h5></template>
        <div class="d-block text-center fs-5">
          Selamat
          <strong class="text-capitalize">{{
            setCekDetailUjian && setCekDetailUjian.nama_user
          }}</strong
          >, Kamu telah menyelesaikan ujian
          <i>{{ setCekDetailUjian && setCekDetailUjian.paket }}</i
          >. Mohon tunggu ya, nilai kamu sedang di proses!
        </div>
        <div class="d-flex justify-content-center">
          <div class="custom-loader"></div>
        </div>
      </b-modal>

      <!-- Start Exam Section -->
      <div class="row mt-3 mb-4 g-3">
        <!-- First Column - Soal Counter -->
        <div class="col-6 col-md-4">
          <div class="d-flex justify-content-center justify-content-md-start">
            <div class="bg-timer w-100 w-md-auto text-center shadow">
              Soal
              {{
                setCekDetailUjian.paket == "Test Kecermatan"
                  ? currentIndex + 1
                  : Math.min(currentIndexSoalAll + 1, setLengthDataId || 0)
              }}
              /
              {{
                setCekDetailUjian.paket == "Test Kecermatan"
                  ? setCekDetailUjian.soal_per_kolom
                  : setCekDetailUjian.length_soal
              }}
            </div>
          </div>
        </div>

        <!-- Middle Column - Refresh Button or Kolom Counter -->
        <div class="col-6 col-md-4">
          <div class="d-flex justify-content-md-center">
            <!-- Refresh Button -->
            <div
              v-if="
                setCekDetailUjian &&
                  setCekDetailUjian.paket !== 'Test Kecermatan'
              "
            >
              <b-button
                @click="refreshSoal"
                class="bg-timer"
                style="background-color: #503668; color: #fff;"
              >
                <span class="d-inline-block me-2">Refresh Soal</span>
                <i class="fa fa-sync-alt fs-custom"></i>
              </b-button>
            </div>

            <!-- Kolom Counter -->
            <div
              v-if="
                setCekDetailUjian &&
                  setCekDetailUjian.paket === 'Test Kecermatan'
              "
              class="bg-timer bg-info text-white text-center w-100 w-md-auto shadow"
            >
              Kolom {{ currentIndexKolom }} / {{ setKolom }}
            </div>
          </div>
        </div>

        <!-- Last Column - Timer -->
        <div class="col-12 col-md-4">
          <div class="d-flex justify-content-md-end">
            <div class="bg-timer text-center w-100 shadow">
              Waktu Tersisa:
              <b>
                <span id="countdown">{{ timer }}</span>
              </b>
            </div>
          </div>
        </div>
      </div>

      <div v-if="minJawab !== true">
        <b-alert show variant="warning">Jawaban Harus Lebih Dari 1</b-alert>
      </div>

      <div v-if="isLoading !== true">
        <div v-if="showNotice === true">
          <b-alert show variant="warning">Waktu tinggal 15 detik</b-alert>
        </div>
        <div
          v-if="
            setCekDetailUjian && setCekDetailUjian.paket === 'Test Kecermatan'
          "
        >
          <kecermatan-vue
            @nextQuestion="readSoal"
            :dataSoal="setSoal"
            :userId="setUserBySoal"
            :idNextSoal="currentIndexKecermatan"
          ></kecermatan-vue>
        </div>

        <div class="col-md-12" v-else>
          <div v-if="setSoal && setSoal.soal">
            <lainnya-vue
              ref="lainnyaRef"
              @nextQuestion="readSoal"
              :dataSoal="setSoal"
              :userId="setUserBySoal"
              :currentIndexAll="currentIndexSoalAll"
              :jawabanUser="jawabanUser"
            ></lainnya-vue>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mb-3 mt-5" v-else>
        <loading-vue></loading-vue>
      </div>

      <b-card
        class="shadow-primary mt-3 mb-3"
        style="border-radius: 12px; border: 1px solid #F3EEF6"
        no-body
      >
        <b-card-footer
          class="d-none"
          v-if="
            setCekDetailUjian && setCekDetailUjian.paket === 'Test Kecermatan'
          "
        >
        </b-card-footer>

        <b-card-footer
          v-else-if="
            setCekDetailUjian && setCekDetailUjian.paket === 'Test Kepribadian'
          "
        >
          <div class="row align-items-center">
            <div class="col">
              <h4 class="m-0">Selamat Ujian</h4>
            </div>
            <div
              :class="
                'col ' +
                  (setDataMultiple !== false && isFinish !== false
                    ? 'text-center'
                    : 'text-end')
              "
            >
              <img
                src="@/assets/logo-shanrise.png"
                alt
                style="height: 4rem; padding: 10px;"
              />
            </div>
            <div
              class="col text-end"
              v-if="setDataMultiple !== false && isFinish !== false"
            >
              <b-button
                @click="submitConfirm"
                variant="success"
                class="btn-round btn-md"
                style="border-radius:30px;"
              >
                <span class="d-sm-inline-block me-2">Simpan Jawaban</span>
                <i class="fa fa-chevron-circle-right fa-lg"></i>
              </b-button>
            </div>
          </div>
        </b-card-footer>

        <b-card-footer v-else>
          <div class="row justify-content-between">
            <div class="col text-start text-md-start">
              <b-button
                @click="fetchPrev"
                variant="danger"
                class="btn-round btn-md"
                style="border-radius:30px; font-size: clamp(0.7rem, 1vw, 2rem);"
                :disabled="isDisabled"
              >
                <i class="fa fa-chevron-circle-left fa-lg"></i>
                <span class="d-sm-inline-block ms-2 d-none">
                  Soal sebelumnya
                </span>
              </b-button>
            </div>

            <div
              class="col text-center text-md-center"
              v-if="
                setCekDetailUjian &&
                  setCekDetailUjian.paket !== 'Test Kepribadian' &&
                  setCekDetailUjian.paket !== 'Test Kecermatan'
              "
            >
              <b-button
                variant="primary"
                class="btn-round btn-md"
                style="border-radius:30px; font-size: clamp(0.7rem, 1vw, 2rem);"
                v-b-modal.modal-daftar-soal
                @click="buttonListSoal"
              >
                <span class="me-md-2 me-2 d-none d-sm-inline-block">
                  Daftar Soal
                </span>
                <i class="fa fa-th-large me-md-1 fs-custom"></i>
              </b-button>
            </div>

            <div
              class="col text-end text-md-end"
              v-if="setDataMultiple !== true && isFinish !== true"
            >
              <b-button
                @click="fetchNext"
                variant="info"
                class="btn-round btn-md"
                style="border-radius:30px; font-size: clamp(0.7rem, 1vw, 2rem);"
                :disabled="setDataMultiple !== false && isFinish !== true"
              >
                <span class="d-sm-inline-block me-2 d-none"
                  >Soal berikutnya</span
                >
                <i class="fa fa-chevron-circle-right fa-lg"></i>
              </b-button>
            </div>

            <div
              class="col text-end text-md-end"
              v-else-if="setDataMultiple !== false && isFinish !== true"
            >
              <b-button
                @click="submitCheckbox"
                variant="purple"
                class="btn-round btn-md"
                style="border-radius:30px;"
              >
                <span class="d-sm-inline-block me-2 d-none"
                  >Soal berikutnya</span
                >
                <i class="fa fa-chevron-circle-right fa-lg"></i>
              </b-button>
            </div>

            <div
              class="col text-end text-md-end"
              v-else-if="setDataMultiple !== false && isFinish !== false"
            >
              <b-button
                @click="submitConfirm"
                variant="success"
                class="btn-round btn-md"
                style="border-radius:30px;"
              >
                <span class="d-sm-inline-block me-2 d-none d-sm-block">
                  Simpan Jawaban
                </span>
                <i class="fa fa-chevron-circle-right fa-lg"></i>
              </b-button>
            </div>

            <div
              class="col text-end text-md-end"
              v-else-if="isFinish !== false"
            >
              <b-button
                @click="submitConfirm"
                variant="success"
                class="btn-round btn-md"
                style="border-radius:30px; font-size: clamp(0.7rem, 1vw, 2rem);"
                :disabled="isDisabled"
              >
                <span class="d-sm-inline-block me-2 d-none">
                  Simpan Jawaban
                </span>
                <i class="fa fa-chevron-circle-right fa-lg"></i>
              </b-button>
            </div>
          </div>
        </b-card-footer>
      </b-card>
    </div>

    <!-- Daftar soal -->
    <div class="row">
      <div class="col-lg-12">
        <b-modal
          id="modal-daftar-soal"
          ref="modal-daftar-soal"
          centered
          size="xl"
          title="Daftar Soal"
          title-class="font-18"
          hide-footer
        >
          <div class="text-center" v-if="isLoading !== true">
            <span v-for="(item, index) in dataSoalExamAll" :key="item && item.soal ? item.soal.id : index">
              <span v-if="item && item.soal && foundItems.includes(item.soal.id)">
                <b-button
                  variant="purple"
                  class="mx-2 my-2 fs-5"
                  style="width: 4.5rem;"
                  @click="listSoal(index)"
                >
                  {{ index + 1 }}
                </b-button>
              </span>
              <span v-else>
                <b-button
                  variant="outline-purple"
                  class="mx-2 my-2 fs-5"
                  style="width: 4.5rem;"
                  @click="listSoal(index)"
                >
                  {{ index + 1 }}
                </b-button>
              </span>
            </span>
          </div>
          <div class="d-flex justify-content-center mb-3" v-else>
            <loading-vue></loading-vue>
          </div>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
